import React, { Component } from "react";
import { Breadcrumb, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import Moment from "react-moment";
import Spinner from "react-bootstrap/Spinner";
import { Button, FormGroup, Input } from "reactstrap";
import Dropzone from "react-dropzone";
import {
  MdOutlineCheck,
  MdOutlineChevronLeft,
  MdOutlineClose,
} from "react-icons/md";
import { toast } from "react-toastify";

class pendingView extends Component {
  constructor(props) {
    super(props);
    let search = this.props.location.search;
    let params = new URLSearchParams(search);

    var Referenceno = params.get("referenceno");
    this.state = {
      file: null,
      downloadData: undefined,
      isFunctionCalled: false,
      isModalOpen: false,
      referenceNo: Referenceno,
      loading: "",
      remarks: "",
      requesterId: 0,
      typeOfExit: 0,
      typeOfExitName: "",
      dateJoined: "",
      approverSection: "",
      lastDayofService: "",
      phoneNumber: "",
      address: "",
      actionCategory: "",
      companycode: "",
      companyName: "",
      divisionName: "",
      divisioncode: "",
      actionType: 0,
      employeeId: "",
      employeeName: "",
      eDocType: "",
      startDate: "",
      endDate: "",
      positionId: "",
      salaryGrade: "",
      workingGroup: "",
      additionalInformation: "",
      description: "",
      userId: this.props.UserId,
      section: "",
      division: "",
      department: "",
      designation: "",
      requesterName: "",
      referenceLinkList: [
        {
          reflink: "",
          remarks: "",
        },
      ],
      attachmentList: [
        {
          referenceNo: "",
          filename: "",
          filetype: "",
          remarks: "",
          userId: 0,
        },
      ],
      empLastDayService: "",
      noticePeriodtoServe: 0,
      noticePeriodtoLieu: 0,
      annualLeaveBal: 0,
      exitInterview: "",
      employmentPass: "",
      ePass: "",
      medicalCard: "",
      hrRemarks: "",
      files: "",
      documents: "",
      fixedAsset: "",
      cash: "",
      locker: "",
      keys: "",
      managerRemarks: "",
      exceedMC: 0,
      exceedMedEnt: "",
      motorVehicleLoan: "",
      motorVehicleRemarks: "",
      trainingBond: "",
      coEremarks: "",
      staffAdvOutstand: "",
      financeRemarks: "",
      ictUserID: "",
      ictUserIDRemarks: "",
      ictAsset: "",
      ictAssetRemarks: "",
      ppe: "",
      ppeRemarks: "",
      techEquip: "",
      techEquipRemarks: "",
      vehicleEntryPass: "",
      companyCar: "",
      compAccomm: "",
      admSvRemarks: "",
      flat: "",
      flatRemarks: "",
      AttachmentsLoader: "no",
      AttachmentslistArray: [],
      editAttachments: false,
      editAttachments_Sequenceno: "",
      editAttachments_Remarks: "",
      attachmentdeletePopup: false,
      attachmentdeleteid: "",
      editAttachments_Filename: "",
      editAttachments_Filetype: "",
      editAttachments_URL: "",
    };
  }

  componentDidMount() {
    //this.getApproverList();
    this.setState({ loading: "Yes" });
    this.props.dispatch({ type: "headerTitle", value: "Pending : View" });
    this.geteDocRequest();
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  // getApproverList = () => {
  //   try {
  //     fetch(
  //       process.env.REACT_APP_WEB_SERVICE_URL +
  //         `/api/eDoc/GetApprovers?ReferenceNo=${this.state.referenceNo}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: "Bearer " + this.props.getToken,
  //         },
  //       }
  //     )
  //       .then((response) => {
  //         if (response.status === 200) {
  //           return response.json();
  //         } else if (response.status === 401) {
  //           this.props.dispatch({ type: "Referenceno", value: "" });
  //           this.props.dispatch({ type: "UserId", value: "" });
  //           this.props.dispatch({ type: "profile", value: "" });
  //           this.props.dispatch({ type: "headerTitle", value: "" });
  //           this.props.dispatch({ type: "Token", value: "" });
  //           this.props.dispatch({ type: "userType", value: "" });
  //           this.props.dispatch({ type: "userName", value: "" });
  //         }
  //       })
  //       .then((data) => {
  //         if (data) {
  //           for (const element of data.resultObject) {
  //             if (element.oriapproverid == this.props.UserId) {
  //               this.setState({
  //                 approverSection: element.section,
  //                 loading: "",
  //               });
  //             }
  //           }
  //         }
  //       })
  //       .catch((error) => {
  //         this.props.dispatch({ type: "Referenceno", value: "" });
  //         this.props.dispatch({ type: "UserId", value: "" });
  //         this.props.dispatch({ type: "profile", value: "" });
  //         this.props.dispatch({ type: "headerTitle", value: "" });
  //         this.props.dispatch({ type: "Token", value: "" });
  //         this.props.dispatch({ type: "userType", value: "" });
  //         this.props.dispatch({ type: "userName", value: "" });
  //       });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  geteDocRequest = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/eDocDetails?ReferenceNo=${this.state.referenceNo}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            if (data.resultObject) {
              this.setState({
                referenceNo: data.resultObject.referenceNo,
                requesterId: data.resultObject.requesterId,
                typeOfExit: data.resultObject.typeOfExitName,
                typeOfExitName: data.resultObject.typeOfExitName,
                dateJoined: data.resultObject.dateJoined,
                lastDayofService: data.resultObject.lastDayofService,
                phoneNumber: data.resultObject.phoneNumber,
                address: data.resultObject.address,
                actionCategory: data.resultObject.actionCategory,
                companycode: data.resultObject.companycode,
                companyName: data.resultObject.companyName,
                divisionName: data.resultObject.divisionName,
                divisioncode: data.resultObject.divisioncode,
                actionType: data.resultObject.actionTypeName,
                employeeId: data.resultObject.employeeId,
                eDocType: data.resultObject.eDocType,
                employeeName: data.resultObject.employeeName,
                startDate: data.resultObject.startDate,
                endDate: data.resultObject.endDate,
                positionId: data.resultObject.positionId,
                salaryGrade: data.resultObject.salaryGrade,
                workingGroup: data.resultObject.workingGroup,
                additionalInformation: data.resultObject.additionalInformation,
                description: data.resultObject.description,
                userId: data.resultObject.userId,
                referenceLinkList: data.resultObject.referenceLinkList,
                attachmentList: data.resultObject.attachmentList,
                requesterName:
                  data.resultObject.requesterId +
                  " - " +
                  data.resultObject.requesterName,
                section: data.resultObject.section,
                department: data.resultObject.department,
                division: data.resultObject.division,
                designation: data.resultObject.designation,
                loading: "",
                // approverSection: data.resultObject.approverSection,
                empLastDayService: data.resultObject.lastDayofService
                  ? data.resultObject.lastDayofService.split("T")[0]
                  : data.resultObject.lastDayofService,
              });
            }
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
      this.GetAttachmentslistData();
    } catch (e) {
      console.log(e);
    }
  };

  handleFileDownload = async (url) => {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const fileUrl = URL.createObjectURL(blob);
      this.setState({ file: fileUrl });
      this.openModal();
      return null;
    } catch (error) {
      console.error("Error downloading file:", error.message);
    }
  };

  downloadFile = (data, type) => {
    try {
      if (!data?.filePath && !data?.fileRecord) {
        toast.info("The specified file or path not found", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        return;
      }
      const fileExtension = data.filename.split(".").pop().toLowerCase();
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/Attachment/${
            data?.filePath
              ? `DownloadFromAzure?FilePath=${data?.filePath}`
              : `DownloadFile?SequenceNo=${data?.sequenceNo}`
          }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            if (type === "view") {
              if (
                [
                  "html",
                  "htm",
                  "pdf",
                  "txt",
                  "jpg",
                  "jpeg",
                  "png",
                  "gif",
                  "bmp",
                  "mp3",
                  "mp4",
                ].includes(fileExtension)
              ) {
                this.handleFileDownload(response.url);
                this.setState({ downloadData: data });
                return null;
              } else {
                toast.info("This file can only be downloaded", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
                window.open(response.url, "_blank");
              }
            } else {
              return window.open(response.url, "_blank");
            }
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  approverRequest = () => {
    try {
      if (
        this.state.remarks &&
        (this.state.approverSection == "HR Operation" ||
        this.state.approverSection == "HR (SU / MBU / BG1)" ||
        this.state.approverSection == "HR (HEO / BG2)"
          ? this.state.empLastDayService &&
            this.state.noticePeriodtoServe &&
            this.state.noticePeriodtoLieu
          : true)
      ) {
        let postData = {
          referenceNo: this.state.referenceNo,
          userId: parseInt(this.props.UserId),
          remarks: this.state.remarks,
          wfStatus: "Approved",
          empLastDayService: this.state.empLastDayService
            ? this.state.empLastDayService
            : null,
          noticePeriodtoServe: this.state.noticePeriodtoServe,
          noticePeriodtoLieu: this.state.noticePeriodtoLieu,
          annualLeaveBal: this.state.annualLeaveBal,
          exitInterview: this.state.exitInterview,
          employmentPass: this.state.employmentPass,
          ePass: this.state.ePass,
          medicalCard: this.state.medicalCard,
          hrRemarks: this.state.hrRemarks,
          files: this.state.files,
          documents: this.state.documents,
          fixedAsset: this.state.fixedAsset,
          cash: this.state.cash,
          locker: this.state.locker,
          keys: this.state.keys,
          managerRemarks: this.state.managerRemarks,
          exceedMC: this.state.exceedMC,
          exceedMedEnt: this.state.exceedMedEnt,
          medicalRemarks: this.state.medicalRemarks,
          motorVehicleLoan: this.state.motorVehicleLoan,
          motorVehicleRemarks: this.state.motorVehicleRemarks,
          trainingBond: this.state.trainingBond,
          coEremarks: this.state.coEremarks,
          staffAdvOutstand: this.state.staffAdvOutstand,
          financeRemarks: this.state.financeRemarks,
          ictUserID: this.state.ictUserID,
          ictUserIDRemarks: this.state.ictUserIDRemarks,
          ictAsset: this.state.ictAsset,
          ictAssetRemarks: this.state.ictAssetRemarks,
          ppe: this.state.ppe,
          ppeRemarks: this.state.ppeRemarks,
          techEquip: this.state.techEquip,
          techEquipRemarks: this.state.techEquipRemarks,
          vehicleEntryPass: this.state.vehicleEntryPass,
          companyCar: this.state.companyCar,
          compAccomm: this.state.compAccomm,
          admSvRemarks: this.state.admSvRemarks,
          flat: this.state.flat,
          flatRemarks: this.state.flatRemarks,
        };
        fetch(
          process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/ApproveRejecteDoc",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            }
          })
          .then((data) => {
            if (data) {
              toast.success("Request approved successfully.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
              this.props.history.push({ pathname: "/mytask/pending/list" });
            }
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      } else {
        this.setState({ errorStatus: true });
      }
    } catch (e) {
      console.log(e);
    }
  };

  editAttachmentsShow = (Sequenceno, remarks) => {
    //alert(Remarks)
    this.setState({
      editAttachments: true,
      editAttachments_Sequenceno: Sequenceno,
      editAttachments_Remarks: remarks,
    });
  };

  deleteAttachment = (id) => {
    this.setState({ attachmentdeletePopup: true, attachmentdeleteid: id });
  };

  rejectRequest = () => {
    try {
      if (this.state.remarks) {
        let postData = {
          referenceNo: this.state.referenceNo,
          userId: parseInt(this.props.UserId),
          remarks: this.state.remarks,
          wfStatus: "Rejected",
        };
        fetch(
          process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/ApproveRejecteDoc",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            }
          })
          .then((data) => {
            if (data) {
              toast.success("Request rejected successfully.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
              this.props.history.push({ pathname: "/mytask/pending/list" });
            }
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      } else {
        this.setState({ errorStatus: true });
      }
    } catch (e) {
      console.log(e);
    }
  };

  GetAttachmentslistData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/GetApproverAttachments?ReferenceNo=${
            this.state.referenceNo
          }&UserId=${parseInt(this.props.UserId)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              AttachmentslistArray: data.resultObject,
              AttachmentsLoader: "No",
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  onDrop = (acceptedFiles) => {
    try {
      if (this.state.referenceNo) {
        this.setState({
          showAttachedRequired: false,
          AttachmentsLoader: "Yes",
        });

        acceptedFiles
          .map((file) => {
            if (file.size > 104857600) {
              toast.info("The maximum file size is 100 MB.");
              this.setState({
                showAttachedRequired: false,
                AttachmentsLoader: "No",
              });
              return;
            }
            let data = new FormData();
            data.append("files", file);
            fetch(
              process.env.REACT_APP_WEB_SERVICE_URL +
                `/api/eDoc/UploadApproverAttachments?ReferenceNo=${
                  this.state.referenceNo
                }&UserId=${parseInt(this.props.UserId)}&Remarks=${""}`,
              {
                method: "POST",
                processData: false,
                contentType: false,
                crossDomain: true,
                headers: {
                  "Access-Control-Allow-Origin": "*",
                  Authorization: "Bearer " + this.props.getToken,
                },
                body: data,
              }
            )
              .then((response) => {
                if (response.status === 200) {
                  return response.json();
                } else if (response.status === 401) {
                  this.props.dispatch({ type: "Referenceno", value: "" });
                  this.props.dispatch({ type: "UserId", value: "" });
                  this.props.dispatch({ type: "profile", value: "" });
                  this.props.dispatch({ type: "headerTitle", value: "" });
                  this.props.dispatch({ type: "Token", value: "" });
                  this.props.dispatch({ type: "userType", value: "" });
                  this.props.dispatch({ type: "userName", value: "" });
                }
              })
              .then((data) => {
                if (data) {
                  this.GetAttachmentslistData();
                }
              });
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      }
    } catch (e) {
      console.log(e);
    }
  };

  changeHandler = (e) => {
    switch (e.target.name) {
      case "noticePeriodtoServe":
        this.setState({
          noticePeriodtoServe: parseInt(e.target.value),
        });
        break;
      case "noticePeriodtoLieu":
        this.setState({
          noticePeriodtoLieu: parseInt(e.target.value),
        });
        break;
      case "annualLeaveBal":
        this.setState({
          annualLeaveBal: parseInt(e.target.value),
        });
        break;
      default:
        break;
    }
  };

  cancelattachmentDelete = () => {
    this.setState({ attachmentdeletePopup: false });
  };

  confirmattachmentDelete = () => {
    fetch(
      process.env.REACT_APP_WEB_SERVICE_URL +
        `/api/eDoc/DeleteApproverAttachments?ReferenceNo=${
          this.state.referenceNo
        }&SequenceNo=${parseInt(
          this.state.attachmentdeleteid
        )}&UserId=${parseInt(this.props.UserId)}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        }
      })
      .then((data) => {
        if (data) {
          this.setState({
            attachmentdeleteid: "",
            attachmentdeletePopup: false,
          });
          this.GetAttachmentslistData();
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "Referenceno", value: "" });
        this.props.dispatch({ type: "UserId", value: "" });
        this.props.dispatch({ type: "profile", value: "" });
        this.props.dispatch({ type: "headerTitle", value: "" });
        this.props.dispatch({ type: "Token", value: "" });
        this.props.dispatch({ type: "userType", value: "" });
        this.props.dispatch({ type: "userName", value: "" });
      });
  };
  editAttachmentsHide = () => {
    this.setState({
      editAttachments: false,
      editAttachments_Sequenceno: "",
      editAttachments_Filename: "",
      editAttachments_Filetype: "",
      editAttachments_Remarks: "",
      editAttachments_URL: "",
    });
  };

  UpdateAttachments = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/UpdateApproverAttachments?ReferenceNo=${
            this.state.referenceNo
          }&SequenceNo=${parseInt(
            this.state.editAttachments_Sequenceno
          )}&Remarks=${this.state.editAttachments_Remarks}`,
        {
          method: "POST",
          processData: false,
          contentType: false,
          crossDomain: true,
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              editAttachments: false,
              editAttachments_Sequenceno: "",
              editAttachments_Filename: "",
              editAttachments_Filetype: "",
              editAttachments_URL: "",
              editAttachments_Remarks: "",
            });
            this.GetAttachmentslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
              Dashboard
            </Breadcrumb.Item>
            <Breadcrumb.Item
              href={process.env.REACT_APP_ENV + "/mytask/pending/list"}>
              Pending : View
            </Breadcrumb.Item>
            <Breadcrumb.Item active>View</Breadcrumb.Item>
          </Breadcrumb>

          <div className="content-area">
            <section>
              <div style={{ margin: "auto", width: "0%" }}>
                <Spinner animation="border" variant="primary" />
              </div>
            </section>
          </div>
        </>
      );
    } else {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
              Dashboard
            </Breadcrumb.Item>
            <Breadcrumb.Item
              href={process.env.REACT_APP_ENV + "/mytask/pending/list"}>
              Pending : View
            </Breadcrumb.Item>
            <Breadcrumb.Item active>View</Breadcrumb.Item>
          </Breadcrumb>
          <div className="content-area">
            <section>
              <div className="form-group mb-2">
                <div className="pending-status">
                  <div className="">
                    <span className="mytask-pending-text">
                      Reference No.{" "}
                      <span className="d-none d-sm-inline"> :</span>
                    </span>{" "}
                    <span className="mytask-reference-text ">
                      {this.state.referenceNo}
                    </span>
                  </div>
                  <div className="">
                    <span className="mytask-pending-text">Status</span>{" "}
                    <div className="badge badge-mytask-pending">Pending</div>
                  </div>
                </div>
              </div>
            </section>
            <section className="view-taskpending-section">
              <h2 className="form-heading">Requester Information</h2>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info  col-form-label">
                  {" "}
                  Staff No / Name{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.requesterName}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Section
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.section}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Department{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.department}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Division{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.division}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Designation{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.designation}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="view-taskpending-section">
              <h2 className="form-heading"> Requisition Details</h2>

              {this.state.eDocType?.includes("Employee Clearance") && (
                <div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      eDoc Type{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.eDocType}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Type of Exit{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.typeOfExitName}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Date of Joined{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.dateJoined && (
                                <Moment format="DD-MM-YYYY">
                                  {this.state.dateJoined}
                                </Moment>
                              )}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Last Day of Service{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              :{" "}
                            </span>
                            <span className="mytask-reference-text">
                              <Moment format="DD-MM-YYYY">
                                {this.state.lastDayofService}
                              </Moment>
                            </span>
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Phone Number{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.phoneNumber}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Address{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.address}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Description{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="d-flex align-items-baseline">
                        <p className="">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                          </>{" "}
                        </p>
                        <p
                          className="mytask-reference-text"
                          style={{ marginLeft: 5, marginTop: 9 }}
                          dangerouslySetInnerHTML={{
                            __html: this.state.description,
                          }}></p>
                      </div>
                    </div>
                    {/* <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.description}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div> */}
                  </div>
                </div>
              )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "Single" && (
                  <div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionCategory}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Company Code
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.companyName}
                              </span>
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Division Code{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.divisionName}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        EmployeeId / Name{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.employeeName}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Position ID{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.positionId}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Salary Grade{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.salaryGrade}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Working Group{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.workingGroup}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Addtional Information{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.additionalInformation}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Start Date{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.startDate && (
                                  <Moment format="DD-MM-YYYY">
                                    {this.state.startDate}
                                  </Moment>
                                )}
                              </span>
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        End Date{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.endDate && (
                                  <Moment format="DD-MM-YYYY">
                                    {this.state.endDate}
                                  </Moment>
                                )}
                              </span>
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Description{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="d-flex align-items-baseline">
                          <p className="">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                            </>{" "}
                          </p>
                          <p
                            className="mytask-reference-text"
                            style={{ marginLeft: 5, marginTop: 9 }}
                            dangerouslySetInnerHTML={{
                              __html: this.state.description,
                            }}></p>
                        </div>
                      </div>
                      {/* <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "Group" && (
                  <div>
                    <div className="form-group requester-info row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionCategory}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "None" && (
                  <div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionCategory}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Others{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.additionalInformation}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {this.state.eDocType != "HRIS" &&
                !this.state.eDocType?.includes("Employee Clearance") && (
                  <div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Description{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="d-flex align-items-baseline">
                          <p className="">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                            </>{" "}
                          </p>
                          <p
                            className="mytask-reference-text"
                            style={{ marginLeft: 5, marginTop: 9 }}
                            dangerouslySetInnerHTML={{
                              __html: this.state.description,
                            }}></p>
                        </div>
                      </div>
                      {/* <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
            </section>
            <section>
              <h2 className="form-heading"> Attachments </h2>
              <table className="table table-bordered overflow-auto-x">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"> File Name </th>
                    {/* <th scope="col"> File Type </th> */}
                    <th scope="col"> Remarks </th>
                    <th scope="col"> Action </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.attachmentList?.map((data, index) => (
                    <>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.filename}</td>
                        {/* <td>{data.filetype}</td> */}
                        <td>{data.remarks}</td>
                        <td>
                          <a
                            onClick={() => this.downloadFile(data, "view")}
                            target="_blank">
                            <img
                              className="action-right-space mouse-pointer"
                              src={
                                process.env.REACT_APP_ENV +
                                "/assets/images/icons/action/awesome-eye.svg"
                              }
                              alt="View"
                              data-tip="View"
                            />
                          </a>
                        </td>
                      </tr>
                      <Modal
                        show={this.state.isModalOpen}
                        onHide={this.closeModal}
                        size="xl">
                        <Modal.Header closeButton>
                          <Modal.Title>Attachment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {" "}
                          <div>
                            {this.state.file ? (
                              <iframe
                                src={this.state.file}
                                title="File Viewer"
                                width="100%"
                                height="500px"></iframe>
                            ) : (
                              <p>Loading...</p>
                            )}
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="primary"
                            onClick={() =>
                              this.downloadFile(this.state.downloadData)
                            }>
                            Download
                          </Button>
                          <Button variant="secondary" onClick={this.closeModal}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                  ))}
                </tbody>
              </table>
              {(() => {
                if (this.state.attachmentList?.length <= 0) {
                  return (
                    <div>
                      <p className="text-center">No record found.</p>
                    </div>
                  );
                }
              })()}
              <h2 className="form-heading"> References </h2>
              <table className="table table-bordered ">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"> Reference Link </th>
                    <th scope="col"> Remarks </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.referenceLinkList?.map((data, index) => (
                    <tr>
                      <td>{data.rowno}</td>
                      <td>
                        <u
                          style={{
                            color: "blue",
                            cursor: "pointer",
                          }}>
                          <a
                            onClick={() =>
                              data.reflink.includes("https")
                                ? window.open(data.reflink, "_blank")
                                : window.open(
                                    `https://${data.reflink}`,
                                    "_blank"
                                  )
                            }>
                            {data.reflink}
                          </a>
                        </u>
                      </td>
                      <td>{data.remarks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {(() => {
                if (this.state.referenceLinkList?.length <= 0) {
                  return (
                    <div>
                      <p className="text-center">No record found.</p>
                    </div>
                  );
                }
              })()}
            </section>
            {(this.state.approverSection == "HR Operation" ||
              this.state.approverSection == "HR (SU / MBU / BG1)" ||
              this.state.approverSection == "HR (HEO / BG2)") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">HR Operation</h2>
                <div className="form-group row mb-0">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Employee Last day of Service
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        value={this.state.empLastDayService}
                        onChange={(e) =>
                          this.setState({ empLastDayService: e.target.value })
                        }
                        type="date"
                      />
                    </FormGroup>
                    {this.state.errorStatus &&
                      !this.state.empLastDayService && (
                        <div class="col-sm-12">
                          <p style={{ color: "red", fontSize: "14px" }}>
                            This field is required *
                          </p>
                        </div>
                      )}
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Notice Period to Serve
                    <span style={{ color: "#B41616" }}>*</span>
                    <br /> (Days)
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        name="noticePeriodtoServe"
                        onChange={this.changeHandler}
                        min="0"
                        type="number"
                      />
                    </FormGroup>
                    {this.state.errorStatus &&
                      !this.state.noticePeriodtoServe && (
                        <div class="col-sm-12">
                          <p style={{ color: "red", fontSize: "14px" }}>
                            This field is required *
                          </p>
                        </div>
                      )}
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Notice Period in Lieu
                    <span style={{ color: "#B41616" }}>*</span>
                    <br /> (Days)
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        name="noticePeriodtoLieu"
                        min="0"
                        onChange={this.changeHandler}
                        type="number"
                      />
                    </FormGroup>
                    {this.state.errorStatus &&
                      !this.state.noticePeriodtoLieu && (
                        <div class="col-sm-12">
                          <p style={{ color: "red", fontSize: "14px" }}>
                            This field is required *
                          </p>
                        </div>
                      )}
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    1. Annual Leave Balance
                    <span style={{ color: "#B41616" }}>*</span>
                    <br /> (Days)
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        name="annualLeaveBal"
                        onChange={this.changeHandler}
                        type="number"
                        min="0"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    2. Exit Interview
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ exitInterview: "Yes" })}
                        className="form-check-input"
                        type="radio"
                        checked={this.state.exitInterview == "Yes"}
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ exitInterview: "No" })}
                        checked={this.state.exitInterview == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ exitInterview: "NA" })}
                        checked={this.state.exitInterview == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    3. Employment Pass
                    <span style={{ color: "#B41616" }}>*</span>
                    <br /> (Only for Expatriate)
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ employmentPass: "Yes" })}
                        checked={this.state.employmentPass == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ employmentPass: "No" })}
                        checked={this.state.employmentPass == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ employmentPass: "NA" })}
                        checked={this.state.employmentPass == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    4. E-Pass
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ePass: "Yes" })}
                        checked={this.state.ePass == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ePass: "No" })}
                        checked={this.state.ePass == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ePass: "NA" })}
                        checked={this.state.ePass == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    5. Medical Card
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ medicalCard: "Yes" })}
                        checked={this.state.medicalCard == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ medicalCard: "No" })}
                        checked={this.state.medicalCard == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ medicalCard: "NA" })}
                        checked={this.state.medicalCard == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        value={this.state.hrRemarks}
                        onChange={(e) =>
                          this.setState({ hrRemarks: e.target.value })
                        }
                        type="textarea"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {this.state.approverSection == "Respective Line Manager" && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Line Manager</h2>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    1. Files
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ files: "Yes" })}
                        checked={this.state.files == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ files: "No" })}
                        checked={this.state.files == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ files: "NA" })}
                        checked={this.state.files == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    2. Documents
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ documents: "Yes" })}
                        checked={this.state.documents == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ documents: "No" })}
                        checked={this.state.documents == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ documents: "NA" })}
                        checked={this.state.documents == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    3. Fixed Assets
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ fixedAsset: "Yes" })}
                        checked={this.state.fixedAsset == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ fixedAsset: "No" })}
                        checked={this.state.fixedAsset == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ fixedAsset: "NA" })}
                        checked={this.state.fixedAsset == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    4. Cash
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ cash: "Yes" })}
                        checked={this.state.cash == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ cash: "No" })}
                        checked={this.state.cash == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ cash: "NA" })}
                        checked={this.state.cash == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    5. Locker
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ locker: "Yes" })}
                        checked={this.state.locker == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ locker: "No" })}
                        checked={this.state.locker == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ locker: "NA" })}
                        checked={this.state.locker == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    6. Keys
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ keys: "Yes" })}
                        checked={this.state.keys == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ keys: "No" })}
                        checked={this.state.keys == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ keys: "NA" })}
                        checked={this.state.keys == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ managerRemarks: e.target.value })
                        }
                        type="textarea"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {this.state.approverSection == "Central HR Services" && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Central HR Service</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Medical
                  </label>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Exceeded MC
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ exceedMC: e.target.value })
                        }
                        type="number"
                        min="0"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Exceeded Medical entitlement
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ exceedMedEnt: e.target.value })
                        }
                        type="text"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection ==
              "Central HR Services - Vehicle Loan" ||
              this.state.approverSection ===
                "Central HR Services- Vehicle Loan") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Central HR Service</h2>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Motor Vehicle Loan
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() =>
                          this.setState({ motorVehicleLoan: "NA" })
                        }
                        checked={this.state.motorVehicleLoan == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() =>
                          this.setState({ motorVehicleLoan: "NA" })
                        }
                        checked={this.state.motorVehicleLoan == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() =>
                          this.setState({ motorVehicleLoan: "NA" })
                        }
                        checked={this.state.motorVehicleLoan == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                    <span style={{ color: "#B41616" }}>*</span>
                  </label>
                  <div className="col-sm-4">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({
                            motorVehicleRemarks: e.target.value,
                          })
                        }
                        type="textarea"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "Finance - Staff Advance" ||
              this.state.approverSection === "Finance- Staff Advance") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Finance</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Staff Advance (Outstanding)
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ staffAdvOutstand: e.target.value })
                        }
                        type="text"
                        placeholder="RM"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        type="textarea"
                        placeholder="Specify item and Amount"
                        onChange={(e) =>
                          this.setState({ financeRemarks: e.target.value })
                        }
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "ICT - AD ID" ||
              this.state.approverSection === "ICT- AD ID") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">ICT</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    User ID
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ictUserID: "Yes" })}
                        checked={this.state.ictUserID == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ictUserID: "No" })}
                        checked={this.state.ictUserID == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ictUserID: "NA" })}
                        checked={this.state.ictUserID == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        type="textarea"
                        placeholder="Specify item and Amount"
                        onChange={(e) =>
                          this.setState({ ictUserIDRemarks: e.target.value })
                        }
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "ICT - Asset" ||
              this.state.approverSection === "ICT- Asset") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">ICT</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    ICT Assets
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ictAsset: "Yes" })}
                        checked={this.state.ictAsset == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ictAsset: "No" })}
                        checked={this.state.ictAsset == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ ictAsset: "NA" })}
                        checked={this.state.ictAsset == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ ictAssetRemarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "Training Center" ||
              this.state.approverSection === "COE- Training Bond") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Training Centre</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Training Bond
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ trainingBond: "Yes" })}
                        checked={this.state.trainingBond == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ trainingBond: "No" })}
                        checked={this.state.trainingBond == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ trainingBond: "NA" })}
                        checked={this.state.trainingBond == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ coEremarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "FAST - Admin Services (Vehicle)" ||
              this.state.approverSection ===
                "FAS- Admin Services (Vehicle Pass)") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Admin Services</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    1. Vehicle Entry Pass
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() =>
                          this.setState({ vehicleEntryPass: "Yes" })
                        }
                        checked={this.state.vehicleEntryPass == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() =>
                          this.setState({ vehicleEntryPass: "No" })
                        }
                        checked={this.state.vehicleEntryPass == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() =>
                          this.setState({ vehicleEntryPass: "NA" })
                        }
                        checked={this.state.vehicleEntryPass == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    2. Company Car
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ companyCar: "Yes" })}
                        checked={this.state.companyCar == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ companyCar: "No" })}
                        checked={this.state.companyCar == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ companyCar: "NA" })}
                        checked={this.state.companyCar == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    3. Company's Accomodation
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ compAccomm: "Yes" })}
                        checked={this.state.compAccomm == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ compAccomm: "No" })}
                        checked={this.state.compAccomm == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ compAccomm: "NA" })}
                        checked={this.state.compAccomm == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ admSvRemarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection ==
              "FAST - Admin Services (MMHE Flat)" ||
              this.state.approverSection ===
                "FAS- Admin Services (MMHE Flat)") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Admin Services</h2>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Flat
                  </label>
                  <div className="col-sm-6 ml-3">
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ flat: "Yes" })}
                        checked={this.state.flat == "Yes"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio1">
                        {" "}
                        Yes{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ flat: "No" })}
                        checked={this.state.flat == "No"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        No{" "}
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <Input
                        onClick={() => this.setState({ flat: "NA" })}
                        checked={this.state.flat == "NA"}
                        className="form-check-input"
                        type="radio"
                      />
                      <label
                        className="form-check-label text-muted"
                        for="inlineRadio2">
                        {" "}
                        Not Applicable{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ flatRemarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "SCM - Tools" ||
              this.state.approverSection == "SCM- Tools") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Supply Chain Management</h2>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Technical Equipment
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ techEquip: e.target.value })
                        }
                        type="text"
                        placeholder="unit(s)"
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ techEquipRemarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            {(this.state.approverSection == "SCM - PPE (Warehouse)" ||
              this.state.approverSection === "SCM- PPE (Warehouse)") && (
              <section className="view-taskpending-section">
                <h2 className="form-heading">Supply Chain Management</h2>
                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Personal protective Equipment <br />
                    (PPE)
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) => this.setState({ ppe: e.target.value })}
                        type="text"
                        placeholder="unit(s)"
                      />
                    </FormGroup>
                  </div>
                </div>

                <div className="form-group row mb-0 mt-4">
                  <label
                    for=""
                    className="col-sm-3 requester-info  col-form-label">
                    Remarks
                  </label>
                  <div className="col-sm-6">
                    <FormGroup>
                      <Input
                        onChange={(e) =>
                          this.setState({ ppeRemarks: e.target.value })
                        }
                        type="textarea"
                        placeholder="Specify item and Amount"
                      />
                    </FormGroup>
                  </div>
                </div>
              </section>
            )}
            <section className="view-taskpending-section">
              <h2 className="form-heading">Attachments</h2>

              <div className="row">
                <div className="col-md-12">
                  <section>
                    <h2 className="fs-title"> </h2>
                    <div>
                      <Dropzone onDrop={this.onDrop}>
                        {({ getRootProps, getInputProps }) => (
                          <div
                            className="jumbotron text-center attachmentStyle"
                            {...getRootProps()}>
                            <input {...getInputProps()} />
                            Drag and drop files , Or click to select attachment
                            files
                          </div>
                        )}
                      </Dropzone>
                    </div>
                    <div className="customized-table">
                      <div className="table-responsive max-height-280">
                        <table className="table table-hover">
                          <thead className="thead-lightBlue">
                            <tr>
                              <th scope="col"> #</th>
                              <th scope="col">File name</th>
                              {/* <th scope="col">File Type</th> */}
                              <th scope="col">Remarks</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.AttachmentslistArray?.map(
                              (loopdata, index) => (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td>{loopdata.filename}</td>
                                  {/* <td>{loopdata.filetype}</td> */}
                                  <td>{loopdata.remarks}</td>
                                  <td>
                                    <div
                                      className="action-icons"
                                      style={{ display: "flex" }}>
                                      <i
                                        className="fa fa-pencil-square-o text-muted"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Edit"
                                        onClick={() =>
                                          this.editAttachmentsShow(
                                            loopdata.sequenceNo,
                                            loopdata.remarks
                                          )
                                        }></i>
                                      <i
                                        className="fa fa-trash-o text-muted"
                                        aria-hidden="true"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Delete"
                                        onClick={() =>
                                          this.deleteAttachment(
                                            loopdata.sequenceNo
                                          )
                                        }></i>
                                    </div>
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                        {(() => {
                          if (this.state.AttachmentslistArray?.length <= 0) {
                            return (
                              <div>
                                <p className="text-center">No record found.</p>
                              </div>
                            );
                          }
                        })()}
                        <p
                          className="text-center"
                          style={{
                            display:
                              this.state.AttachmentsLoader === "Yes"
                                ? ""
                                : "none",
                          }}>
                          <Spinner
                            animation="border"
                            variant="primary"
                            className="text-center"
                          />
                        </p>
                        {/* {this.state.AttachmentslistArray?.length <= 0 &&
                          this.state.errorStatus && (
                            <div className="text-danger text-center">
                              The Attachments is required.
                            </div>
                          )} */}
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </section>
            <section className="view-taskpending-section">
              <h2 className="form-heading">Comments</h2>
              <div className="form-group row mb-0 mt-4">
                <label
                  for=""
                  className="col-sm-3 requester-info  col-form-label">
                  Please give your Comments
                  <span style={{ color: "#B41616" }}>*</span>
                </label>
                <div className="col-sm-4">
                  <FormGroup>
                    <Input
                      onChange={(e) =>
                        this.setState({ remarks: e.target.value })
                      }
                      type="textarea"
                    />
                  </FormGroup>
                  {this.state.errorStatus && !this.state.remarks && (
                    <div class="col-sm-12">
                      <p style={{ color: "red", fontSize: "14px" }}>
                        This field is required *
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="form-group row mb-0 mt-4">
                <div className="comments-button-style">
                  <Button
                    onClick={() =>
                      this.props.history.push({
                        pathname: "/mytask/pending/list",
                      })
                    }
                    className="child-comments"
                    outline
                    variant="light">
                    <MdOutlineChevronLeft
                      className="commects-icons"
                      size={23}
                    />
                    Back
                  </Button>
                  <Button
                    onClick={this.rejectRequest}
                    className="child-comments"
                    variant="danger">
                    <MdOutlineClose className="commects-icons" size={23} />
                    Reject
                  </Button>
                  <Button
                    onClick={this.approverRequest}
                    className="child-comments"
                    variant="success">
                    <MdOutlineCheck className="commects-icons" size={23} />
                    Approve
                  </Button>
                </div>
              </div>
            </section>
            <Modal show={this.state.editAttachments} size="lg">
              <Modal.Header>Edit</Modal.Header>
              <Modal.Body>
                <section className="p-3">
                  <div className="form-group row mb-1">
                    <label
                      for="auth-name"
                      className="col-sm-3 col-form-label text-muted">
                      Remarks
                    </label>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="editAttachments_Remarks"
                          defaultValue={this.state.editAttachments_Remarks}
                          onChange={(e) =>
                            this.setState({
                              editAttachments_Remarks: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <Button
                      className="btn btn-light"
                      onClick={() => this.editAttachmentsHide()}>
                      {" "}
                      Cancel{" "}
                    </Button>
                    <Button
                      className="btn btn-primary-01 ml-3"
                      onClick={this.UpdateAttachments}>
                      {" "}
                      Update{" "}
                    </Button>
                  </div>
                </section>
              </Modal.Body>
            </Modal>
            <Modal show={this.state.attachmentdeletePopup}>
              <Modal.Header>Delete Confirmation</Modal.Header>
              <Modal.Body>
                <div className="alert alert-danger" role="alert">
                  Are you sure you want to delete?
                </div>
                <hr></hr>
                <div className="text-right">
                  <Button
                    className="btn btn-light"
                    onClick={this.cancelattachmentDelete}>
                    {" "}
                    No{" "}
                  </Button>
                  <Button
                    className="btn btn-primary-01 ml-3"
                    onClick={this.confirmattachmentDelete}>
                    {" "}
                    Yes{" "}
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(pendingView);
